<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-row dense v-if="user.tipo == 'ADMIN_PRODUTORA'">
      <v-col cols="12" sm="12" md="6">
        <v-select
          outlined
          dense
          v-model="lojistaSelecionado"
          :items="lojistas"
          item-text="nome"
          item-value="id"
          label="Selecione o lojista"
          @input="carregaTransacoes"
        ></v-select>
      </v-col>
    </v-row>
    <v-layout row wrap>
      <v-flex xs12 sm12 lg2>
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              light
              v-model="dateFormattedInicio"
              label="Data Inicio"
              persistent-hint
              append-icon="event"
              @blur="date = parseDate(dateFormattedInicio)"
              v-on="on"
              outlined
              dense
            ></v-text-field>
          </template>
          <v-date-picker v-model="dataInicio" no-title @input="menu1 = false"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm12 lg1>
        <v-text-field
          v-model="horaInicio"
          label="Hora Início"
          light
          type="time"
          outlined
          dense
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm12 lg2>
        <v-menu
          ref="menu2"
          v-model="menu2"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              light
              v-model="dateFormattedFim"
              label="Data Fim"
              persistent-hint
              append-icon="event"
              @blur="date = parseDate(dateFormattedFim)"
              v-on="on"
              outlined
              dense
            ></v-text-field>
          </template>
          <v-date-picker v-model="dataFim" no-title @input="menu2 = false"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm12 lg1>
        <v-text-field
          v-model="horaFim"
          label="Hora Fim"
          light
          type="time"
          outlined
          dense
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm12 lg1>
        <v-btn dark @click="carregaTransacoes" fab small color="#01579B"><v-icon>search</v-icon></v-btn>
      </v-flex>
    </v-layout>
    <v-row>
      <v-col ls="12" sm="12" md="12" lg="12">
        <v-data-table
          :search="tabela.busca"    
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          class="elevation-1"
          style="border-radius: 10px;"
          :loading="tabela.carregamento"
          loading-text="Aguarde, buscando transações..."
        >
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">CONSUMOS POR ITEM</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="tabela.busca"
                append-icon="search"
                label="Pesquisa"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
          <template slot="no-data">
            <v-row>
              <v-col>
                <v-alert style="margin-top: 16px" dark dense text outlined :value="true" color="warning" icon="info">Nenhum consumo encontrado</v-alert>
              </v-col>
            </v-row>
          </template>
          <template slot="no-results">
            <v-row>
              <v-col>
                <v-alert style="margin-top: 16px" dark dense text outlined :value="true" color="warning" icon="info">Sua pesquisa por "{{tabela.busca}}" não trouxe resultados</v-alert>
              </v-col>
            </v-row>
          </template>
          <template v-slot:[`item.preco`]="{ item }">
            R$ {{ item.preco }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import moment from 'moment'
  export default {
    components: {Snackbar,},
    data: vm => ({
      date: new Date().toISOString().substr(0, 10),
      mask:"##:##:##",
      menu: false,
      configAccess: false,
      tabela: {
        cabecalho: [
          { text: 'Produto', value: 'descricao' },
          { text: 'Quantidade', value: 'quantidade' },
          { text: 'Lojista', value: 'lojista' },
          { text: 'Valor Unitário', value: 'preco' },
        ],
        conteudo: [],
        busca: '',
        carregamento: false,
      },
      menu1: false,
      menu2: false,
      dateFormattedInicio: vm.formatDate(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      dateFormattedFim: vm.formatDate(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      dataInicio: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dataFim: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      horaInicio: '00:00',
      horaFim: '23:59',
      editedIndexCat: -1,
      editedIndexProd: -1,
      eventos: [],
      eventoId: '',
      eventoIdAtual: '',
      lojistaSelecionado: '',
      lojistas: [],
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitleProd () {
        return this.editedIndexProd === -1 ? 'ADICIONAR NOVO PRODUTO' : 'EDITAR PRODUTO'
      },  
      computedDateFormattedInicio () {
        return this.formatDate(this.dataInicio)
      },
      computedDateFormattedFim () {
        return this.formatDate(this.dataFim)
      },
    }),

    watch: {
      configAccess (val) {
        if (val == true)
          this.openDialog()
      },
      dataInicio() {
        this.dateFormattedInicio = this.formatDate(this.dataInicio)
      },
      dataFim() {
        this.dateFormattedFim = this.formatDate(this.dataFim)
      },
    },

    mounted () {
      if (this.user.tipo == 'ADMIN_PRODUTORA') {
        this.carregaLojistas()
      } else {
        this.carregaTransacoes()
      }
    },

    methods: {
      async carregaLojistas() {
        await axios.get(baseApiUrl + 'Lojistas?filter={"where":{"empresaId":"' + this.user.empresaId + '"}, "order":"nome ASC" ,"fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.lojistas = response.data
          }
        })
      },

      async carregaTransacoes () {
        this.tabela.carregamento = true
        this.tabela.conteudo = []
        let conteudo = []
        let url = ''

        if (this.user.tipo == 'ADMIN') {
          url = baseApiUrl + 'ExtratoCartoes?filter={"where":{"and":[{"tipoTransacao":"CONSUMO"},{"created":{"gte":"' + this.dataInicio + 'T' + this.horaInicio + ':00.000Z"}},{"created":{"lte":"' + this.dataFim + 'T' + this.horaFim + ':00.000Z"}}]}, "fields":{"id": true, "itens": true, "lojistaId": true, "estornado": true}, "include": "lojista"}&access_token='+sessionStorage.getItem('accToken')
        } else if (this.user.tipo == 'ADMIN_LOJISTA') {
          url = baseApiUrl + 'ExtratoCartoes?filter={"where":{"and":[{"lojistaId":"' + this.user.lojistaId + '"},{"tipoTransacao":"CONSUMO"},{"created":{"gte":"' + this.dataInicio + 'T' + this.horaInicio + ':00.000Z"}},{"created":{"lte":"' + this.dataFim + 'T' + this.horaFim + ':00.000Z"}}]}, "fields":{"id": true, "itens": true, "lojistaId": true, "estornado": true}, "include": "lojista"}&access_token='+sessionStorage.getItem('accToken')
        } else if (this.user.tipo == 'ADMIN_PRODUTORA') {
          url = baseApiUrl + 'ExtratoCartoes?filter={"where":{"and":[{"lojistaId":"' + this.lojistaSelecionado + '"},{"tipoTransacao":"CONSUMO"},{"created":{"gte":"' + this.dataInicio + 'T' + this.horaInicio + ':00.000Z"}},{"created":{"lte":"' + this.dataFim + 'T' + this.horaFim + ':00.000Z"}}]}, "fields":{"id": true, "itens": true, "lojistaId": true, "estornado": true}, "include": "lojista"}&access_token='+sessionStorage.getItem('accToken')
        }

        await axios.get(url)
        .then(response => {
          for (let i = 0; i < response.data.length; i++) {
            if (!response.data[i].estornado) {
              response.data[i].itens.forEach(item => {
                if (conteudo.length == 0) {
                  conteudo.push({
                    'quantidade': item.quantidade,
                    'descricao': item.descricao,
                    'produtoId': item.produtoId,
                    'lojista': response.data[i].lojista.nome,
                    'preco': item.preco,
                  })
                } else {
                  let encontrou = false
                  for (let j = 0; j < conteudo.length; j++) {
                    if (conteudo[j].produtoId && item.produtoId && conteudo[j].produtoId == item.produtoId) {
                      conteudo[j].quantidade += item.quantidade
                      encontrou = true
                      break
                    }
                  }
                  if (!encontrou) {
                    conteudo.push({
                      'quantidade': item.quantidade,
                      'descricao': item.descricao,
                      'produtoId': item.produtoId,
                      'lojista': response.data[i].lojista.nome,
                      'preco': item.preco,
                    })
                  }
                }
              });
            }
          }
          
          this.tabela.conteudo = conteudo
          this.tabela.carregamento = false
        })
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateHour(data_hora) {
        let data = data_hora.substr(0, 10).split('-')
        data = data[2] + '/' + data[1] + '/' + data[0]
        let hora = data_hora.substr(11, 8)

        return data + ' ' + hora
      },
      
      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      compare(a) {
        // Use toUpperCase() to ignore character casing
        const dataA = moment(this.formatDateHora(a.fim), 'DD/MM/YYYY HH:mm:ss', true).format()
        //const dataB = new Date(moment(this.formatDatePadrao(b.fim)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z'))
        const dataC = moment().format()

        let comparison = 0;
        if (dataC >= dataA)
          comparison = 1;
        /* else if (dataA >= dataC && dataB < dataA)
          comparison = -1; */
        else if (dataC < dataA)
          comparison = -1;
        return comparison;
      },

      formatDateHora(date) {
        if (!date) return null

        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },

      transformaData(data, formato) {
        let date = moment(data).format(formato);
        return date
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
    font-size: 14px;
  }

  @import '../../node_modules/vue-anka-cropper/dist/VueAnkaCropper.css';
</style>
